module.exports = __webpack_public_path__ + "news-4a753f38/Background_01_4x3_a-b256bf1d14f0a0392d977acdd4c9bf9f.svg";